/**
 * Product localization utilities
 *
 * Primary source: `metadata.translated_title` / `metadata.translated_description`
 * — injected by the enrichProductsWithTranslations middleware from game_translation / book_translation tables.
 *
 * Fallback: product.title / product.description (English from Medusa).
 */

import { HttpTypes } from '@medusajs/types';
import { Locale } from '@/types/i18n';

/**
 * Get localized product content.
 * Priority: middleware-injected translated_title → product.title
 */
export function getLocalizedProductContent(
  product: HttpTypes.StoreProduct,
  _locale: Locale
): {
  title: string;
  subtitle?: string;
  description?: string;
  is_translated: boolean;
} {
  const metadata = product.metadata as Record<string, any> | undefined;
  const translatedTitle = metadata?.translated_title as string | undefined;
  const translatedDescription = metadata?.translated_description as string | undefined;

  if (translatedTitle) {
    return {
      title: translatedTitle,
      subtitle: product.subtitle || undefined,
      description: translatedDescription || product.description || undefined,
      is_translated: true,
    };
  }

  return {
    title: product.title || '',
    subtitle: product.subtitle || undefined,
    description: product.description || undefined,
    is_translated: false,
  };
}

